import { DocumentModel, FilteredDocument } from '../../../common/src';
import * as backendApi from '../shared/backend-api';

export default class DocumentService {
  constructor() {}

  getJournalNotes(): Promise<FilteredDocument[]> {
    return backendApi.get('documents/getJournalNotes');
  }
  downloadProfileDocument(documentId: number): Promise<DocumentModel> {
    return backendApi.post('documents/download-document', { documentId });
  }
}
